import { NgModule } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import {
  AlignedGridsModule,
  CellApiModule,
  CellStyleModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  ColumnApiModule,
  ColumnAutoSizeModule,
  ColumnHoverModule,
  EventApiModule,
  GridStateModule,
  ModuleRegistry,
  PinnedRowModule,
  RenderApiModule,
  RowApiModule,
  RowStyleModule,
  ScrollApiModule,
  TooltipModule,
  ValidationModule,
  ValueCacheModule,
} from 'ag-grid-community';
import {
  CellSelectionModule,
  ClipboardModule,
  ColumnMenuModule,
  ContextMenuModule,
  LicenseManager,
  PivotModule,
  ServerSideRowModelApiModule,
  ServerSideRowModelModule,
  TreeDataModule,
} from 'ag-grid-enterprise';
import { LoadingRectComponent } from 'src/app/shared/components/loading/loading-rect.component';
import { AgGridPivotTableVisualComponent } from './pivotTable/PivotTableVisual.component';
import { AgGridTableVisualComponent } from './table/TableVisual.component';
import { environment } from 'src/environments/environment';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridPivotTableStyleEditorComponent, AgGridTableStyleEditorComponent } from './styleEditor/TableStyleEditorComponent';

ModuleRegistry.registerModules([
  ColumnAutoSizeModule,
  ColumnHoverModule,
  PinnedRowModule,
  RowStyleModule,
  CellStyleModule,
  TooltipModule,
  ValueCacheModule,
  AlignedGridsModule,
  GridStateModule,
  ColumnApiModule,
  RowApiModule,
  CellApiModule,
  ScrollApiModule,
  RenderApiModule,
  EventApiModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  CellSelectionModule,
  ColumnMenuModule,
  ContextMenuModule,
  ServerSideRowModelApiModule,
  ServerSideRowModelModule,
  PivotModule,
  TreeDataModule,
  ClipboardModule,
]);

LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-092917}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{TRG_Screen}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Insights}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Insights}_need_to_be_licensed___{Insights}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{12_September_2026}____[v3]_[01]_MTc4OTE2NzYwMDAwMA==35a587fbd8af28c7069912f421925d93');

if (!environment.production) {
  ModuleRegistry.registerModules([
    ValidationModule,
  ]);
}

@NgModule({
  imports: [
    AgGridAngular,
    LoadingRectComponent,
    SharedModule,
  ],
  declarations: [
    AgGridTableVisualComponent,
    AgGridPivotTableVisualComponent,
  ],
  exports: [
  ],
  providers: [
  ]
})
export class PbirAgGridModule { }
